<!-- 折线图 -->
<template>
    <div class="width_height_100" :id="id"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
    name: "echartLine",
    data() {
        return {
        };
    },
    props: {
        id: {
            type: String,
            default: "line",
        },
        xAxis: {
            type: Array,
            default: function () {
                return ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
            },
        },
        series: {
            type: Array,
            default: function () {
                return [
                    {
                        type: "line",
                        data: [0, 0, 0, 0, 0, 0, 0],
                    },
                ];
            },
        },
    },
    mounted() {
        this.initChat();
    },
    methods: {
        initChat() {
            var chartDom = document.getElementById(this.id);
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                tooltip: {
                    trigger: "axis",
                },
                xAxis: {
                    type: "category",
                    data: this.xAxis,
                },
                yAxis: {
                    type: "value",
                },
                series: this.series,
                grid: {
                    x: 50,
                    y: 50,
                    x2: 30,
                    y2: 50,
                },
            };
            option && myChart.setOption(option);
        },
    },
};
</script>

<style scoped>
.width_height_100 {
    width: 100%;
    height: 100%;
}
</style>